import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Container, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
const LogoReport = "/report-automator-logo.png";

function Logout() {
  const [cookies, setCookie, removeCookie] = useCookies(["login-kiwox-cookies"]);
  const [useByeByeMessage, setUseByeByeMessage] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    removeCookie("login-kiwox-cookies-token", { path: "/" });
    removeCookie("login-kiwox-cookies-redirect", { path: "/" });
    console.debug("LOGOUT");
    if (!useByeByeMessage) navigate("/");
  }, []);

  return (
    <div className="bg-login">
      {useByeByeMessage && <Container className="login-container" component="main">
        <Box className="container-box container-box-login  ">
          <div className="img-margin">
            <img src={LogoReport} alt="report" />
          </div>
          <div className="padding-modal">
            <Typography className="center-elements bold-text " variant="h6">Se ha cerrado su sesi&oacute;n</Typography>
            <Typography className="center-elements" variant="body1">Muchas gracias por utilizar nuestro sitio.</Typography>
          </div>
          <Link to="/">
            <Button type="submit" className="btn-principal" variant="outlined">
              Regresar al inicio de sesi&oacute;n
            </Button>
          </Link>
        </Box>
      </Container>
      }
    </div>
  );
}

export default Logout;
